import {
    CHECK_SKU,
    APPLY_PRODUCT
} from "Actions/applyListing";

const initialState = {
};

export function applyListing(state = initialState, action) {
    switch (action.type) {
        case CHECK_SKU:
        case APPLY_PRODUCT:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}